import React, { useEffect, useRef } from 'react';

const MysticalParticles = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const createParticle = () => {
      const particle = document.createElement('div');
      particle.className = 'particle';
      
      // Random starting position
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDelay = Math.random() * 8 + 's';
      particle.style.animationDuration = (Math.random() * 4 + 6) + 's';
      
      // Random size variation (smaller particles for better performance)
      const size = Math.random() * 2 + 2;
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';
      
      // Random color variation
      const colors = ['#E8CBA0', '#D698CA', '#7862BD', '#D9AC68'];
      particle.style.background = colors[Math.floor(Math.random() * colors.length)];
      
      container.appendChild(particle);
      
      // Remove particle after animation
      setTimeout(() => {
        if (particle.parentNode) {
          particle.parentNode.removeChild(particle);
        }
      }, 10000);
    };

    // Create particles periodically (reduced frequency for better performance)
    const interval = setInterval(createParticle, 500);
    
    // Create initial particles (reduced count for better performance)
    for (let i = 0; i < 10; i++) {
      setTimeout(createParticle, i * 200);
    }

    return () => {
      clearInterval(interval);
    };
  }, []);

  return <div ref={containerRef} className="mystical-particles" />;
};

export default MysticalParticles;
